import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SoftButton from 'components/SoftButton';
import IconButton from '@mui/material/IconButton';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ConsolidadoModal from '../ConsolidadoModal';
import InfoIcon from '@mui/icons-material/Info';

function AddButtonCell({ consolidatedNumber }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        color="warning"
        variant="contained"
        size="medium"
        onClick={handleOpen}
      >
        <InfoIcon />
      </IconButton>
      <ConsolidadoModal
        show={open}
        handleClose={handleClose}
        consolidatedNumber={consolidatedNumber}
      />
    </>
  );
}

// Agrega la validación de PropTypes
AddButtonCell.propTypes = {
  consolidatedNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

AddButtonCell.defaultProps = {
  consolidatedNumber: '',
};

export default AddButtonCell;
